import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface RepuestosLayoutState {
  sidebarCollapsed: boolean
  /** Si el input de búsqueda del catálogo/repuestos está visible. */
  searchOpen: boolean
  setSidebarCollapsed: (collapsed: boolean) => void
  toggleSidebar: () => void
  setSearchOpen: (open: boolean) => void
  toggleSearch: () => void
}

export const useRepuestosLayout = create<RepuestosLayoutState>()(
  persist(
    (set) => ({
      sidebarCollapsed: false,
      searchOpen: false,
      setSidebarCollapsed: (sidebarCollapsed) => set({ sidebarCollapsed }),
      toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
      setSearchOpen: (searchOpen) => set({ searchOpen }),
      toggleSearch: () => set((s) => ({ searchOpen: !s.searchOpen })),
    }),
    {
      name: 'oriental-ramirez-repuestos-sidebar',
      // `searchOpen` es estado efímero de UI: no se persiste.
      partialize: (s) => ({ sidebarCollapsed: s.sidebarCollapsed }),
    }
  )
)
